// Small "Calls: 3 of 7" counter in the page header, owner only. Live count via
// onSnapshot on this week's callSheets doc; clicking reopens the popup (the
// dashboard shell listens for the event and renders CallSheetModal).
// The owner check MUST come before subscribing: callSheets is owner-only in
// Firestore rules, so a non-owner subscription would log permission errors.
import { useEffect, useState } from "react";
import { PhoneCall } from "lucide-react";
import { useStateValue } from "../../context/StateProvider";
import { isSuperAdminOwner } from "../../utils/brokerageSettings";
import { subscribeCurrentSheet } from "../../utils/callSheetStore";

export default function CallSheetChip() {
  const [{ user }] = useStateValue();
  const owner = isSuperAdminOwner(user);
  const [sheet, setSheet] = useState(null);

  useEffect(() => {
    if (!owner) return undefined;
    return subscribeCurrentSheet(setSheet);
  }, [owner]);

  if (!owner || !sheet?.entries?.length) return null;

  const total = sheet.entries.length;
  const called = sheet.entries.filter((e) => e.calledAt).length;
  const done = called >= total;

  return (
    <button
      onClick={() => window.dispatchEvent(new CustomEvent("tes:openCallSheet"))}
      title="Open this week's call sheet"
      className={`hidden sm:inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold border transition ${
        done
          ? "border-emerald-300 bg-emerald-50 text-emerald-700"
          : "border-slate-300 bg-white text-slate-700 hover:bg-slate-50"
      }`}
    >
      <PhoneCall size={13} />
      {done ? "Calls: done" : `Calls: ${called} of ${total}`}
    </button>
  );
}
